// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_f-0";
export var colorSwatch = "_f-5";
export var compactSwatch = "_f-7";
export var fillWidth = "_f-4";
export var iconButton = "_f-2";
export var iconWrapper = "_f-3";
export var shadow = "_f-6";
export var xs = "_f-1";